import type { RuleDefinition } from "../ruleRegistry";

export const PRICES_RULES = [
	{
		id: "prices.golvTakBjalkar",
		category: "prices",
		label: "Golv- & Takbjälkar",
		description: "45×145 K-virke (Byggmax)",
		defaultValue: 42,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.golvBjalkar",
		category: "prices",
		label: "Golvbjälkar",
		description: "45×145 K-virke för bjälklag",
		defaultValue: 42,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.takbjalkar45x145",
		category: "prices",
		label: "Takbjälkar 45×145",
		description: "45×145 K-virke för takreglar",
		defaultValue: 42,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.takbjalkar45x170",
		category: "prices",
		label: "Takbjälkar 45×170",
		description: "45×170 K-virke för takreglar",
		defaultValue: 49,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.takbjalkar45x195",
		category: "prices",
		label: "Takbjälkar 45×195",
		description: "45×195 K-virke för takreglar",
		defaultValue: 56,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.takbjalkar45x220",
		category: "prices",
		label: "Takbjälkar 45×220",
		description: "45×220 K-virke för takreglar",
		defaultValue: 64,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.limtraTakbalk",
		category: "prices",
		label: "Takbalk limträ (riktpris)",
		description:
			"Riktpris per lpm när takbjälkarnas spann är större än spännviddstabellen klarar: limträbalk 56×225 GL28cs i 6 m längd. Den verkliga dimensionen bestäms av konstruktör.",
		defaultValue: 271,
		valueType: "number",
		unit: "kr/lpm",
		source:
			"https://www.beijerbygg.se/privat/sv/produkter/byggmaterial-traprodukter/traprodukter/limtra/limtrabalk-56x225mm-l-6000-gl28cs-9440056225060",
	},
	{
		id: "prices.vaggreglar",
		category: "prices",
		label: "Väggreglar",
		description: "45×95 K-reglar",
		defaultValue: 28,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.syll",
		category: "prices",
		label: "Syll",
		description: "45×95 K-virke",
		defaultValue: 28,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.hammarband",
		category: "prices",
		label: "Hammarband",
		description: "45×95 K-virke",
		defaultValue: 28,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.stenullsisolering",
		category: "prices",
		label: "Stenullsisolering",
		description: "ISOVER Bastumatta 95mm",
		defaultValue: 95,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.bastufolie",
		category: "prices",
		label: "Bastufolie",
		description: "Aluminium bastufolie + tejp",
		defaultValue: 30,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.alutejp",
		category: "prices",
		label: "Alutejp / fogtejp",
		description: "Aluminiumtejp för bastufolie och ångtäta skarvar",
		defaultValue: 129,
		valueType: "number",
		unit: "kr/paket",
	},
	{
		id: "prices.spiklakt",
		category: "prices",
		label: "Spikläkt / Glespanel",
		description: "22×45 mm läkt",
		defaultValue: 12,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.ytterpanel",
		category: "prices",
		label: "Ytterpanel",
		description: "22×120 spontad gran",
		defaultValue: 24,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.vindskydd",
		category: "prices",
		label: "Vindskydd",
		description: "Vindskyddsskiva / diffusionsöppen duk bakom luftspalten",
		defaultValue: 45,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.bastupanel",
		category: "prices",
		label: "Bastupanel (gran)",
		description: "15×90 obehandlad gran",
		defaultValue: 18,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.bastupanelAsp",
		category: "prices",
		label: "Bastupanel (asp)",
		description: "15×90 kvistfri asp (premiumträslag)",
		defaultValue: 55,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.bastupanelAl",
		category: "prices",
		label: "Bastupanel (al)",
		description: "15×90 klibbal — mellan gran och asp i pris",
		defaultValue: 42,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.lavvirke",
		category: "prices",
		label: "Lav-virke",
		description: "28×90 kvistfritt asp",
		defaultValue: 65,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.lavvirkeAl",
		category: "prices",
		label: "Lav-virke (al)",
		description: "28×90 kvistfri klibbal",
		defaultValue: 58,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.lavvirkeGran",
		category: "prices",
		label: "Lav-virke (gran)",
		description:
			"28×90 kvistfri gran — billigast, men kådar och blir hetare än asp/al",
		defaultValue: 30,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.tjarvitriol",
		category: "prices",
		label: "Tjärvitriol",
		description: "Fasadbehandling, cirka 7 m²/liter och en strykning",
		defaultValue: 180,
		valueType: "number",
		unit: "kr/liter",
	},
	{
		id: "prices.jarnvitriol",
		category: "prices",
		label: "Järnvitriol",
		description: "Fasadbehandling, cirka 9 m²/liter och en strykning",
		defaultValue: 55,
		valueType: "number",
		unit: "kr/liter",
	},
	{
		id: "prices.slamfarg",
		category: "prices",
		label: "Slamfärg",
		description: "Falu-typ slamfärg, cirka 4,5 m²/liter och strykning (två lager)",
		defaultValue: 95,
		valueType: "number",
		unit: "kr/liter",
	},
	{
		id: "prices.fukttaligtGolv",
		category: "prices",
		label: "Fukttåligt golv",
		description: "28×120 tryckimpregnerat",
		defaultValue: 285,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.knutbrador",
		category: "prices",
		label: "Knutbrädor",
		description: "22×45 mm fasadavslut",
		defaultValue: 18,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.fonsterfoder",
		category: "prices",
		label: "Fönster- / dörrfoder",
		description: "22×45 mm foder runt dörrar och fönster",
		defaultValue: 22,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.vindskivor",
		category: "prices",
		label: "Vindskivor",
		description: "22×145 mm vindskiva/fascia",
		defaultValue: 28,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.nederkantsavslut",
		category: "prices",
		label: "Nederkantsavslut",
		description: "22×95 mm nederkantsbräda",
		defaultValue: 22,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.takfotsavslut",
		category: "prices",
		label: "Takfotsavslut / Undertak",
		description: "12 mm undertaksskiva",
		defaultValue: 145,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.undergolv",
		category: "prices",
		label: "Undergolv / Trossbotten",
		// Re-specified from 12 mm konstruktionsplywood to 12 mm asfaboard: the
		// trossbotten in a plintgrundad bastustuga is a vindtät men
		// diffusionsöppen asfaltimpregnerad träfiberskiva vilande på läkt, not a
		// structural plywood deck. Board price follows the material (~67-80
		// kr/m² vs plywood's 165).
		description:
			"12 mm asfaboard / trossbottenskiva (asfaltimpregnerad träfiberskiva)",
		defaultValue: 75,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.trossbottenlakt",
		category: "prices",
		label: "Trossbottenläkt 28×70",
		description:
			"Läkt 28×70 spikad mot bjälksidan som upplag för trossbottenskivan",
		defaultValue: 16,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.kortlingRegel",
		category: "prices",
		label: "Kortling / Avväxling 45×95",
		description: "Konstruktionsregel 45×95 för kortlingar och avväxlingar",
		defaultValue: 28,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.bastuDorr",
		category: "prices",
		label: "Bastudörr",
		description: "Bastudörr i härdat glas",
		defaultValue: 4500,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.stavvirke",
		category: "prices",
		label: "Stavvirke",
		description: "38×90 värmebehandlat",
		defaultValue: 65,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.gavlar",
		category: "prices",
		label: "Gavlar",
		description: "Limträ gavelskiva",
		defaultValue: 3500,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.stalband",
		category: "prices",
		label: "Stålband",
		description: "30×3 mm stålband",
		defaultValue: 450,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.vaggor",
		category: "prices",
		label: "Vaggor",
		description: "Profilsågade vaggor",
		defaultValue: 1200,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.golvbrädor",
		category: "prices",
		label: "Golvbrädor",
		description: "28×120 inre golv",
		defaultValue: 285,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.bastuaggregat",
		category: "prices",
		label: "Bastuaggregat",
		description: "Vedeldad bastu-kamin",
		defaultValue: 8500,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.elaggregat",
		category: "prices",
		label: "Elaggregat",
		description: "Elaggregat för bastu, mellansegment",
		defaultValue: 7800,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.aggregatsten",
		category: "prices",
		label: "Aggregatsten",
		description: "Bastusten 20 kg",
		defaultValue: 649,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.styrpanel",
		category: "prices",
		label: "Styrpanel",
		description: "Extern eller integrerad styrning för elaggregat",
		defaultValue: 2500,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.ventiler",
		category: "prices",
		label: "Ventiler",
		description: "Bastuventil (tilluft+frånluft)",
		defaultValue: 350,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.fonster",
		category: "prices",
		label: "Fönster",
		description: "Dubbelt isolerglas",
		defaultValue: 2200,
		valueType: "number",
		unit: "kr/st",
	},
	{
		// Sold by the square metre because the wall is made to measure. Checked
		// 2026-09: single 8 mm tempered sauna glass runs 1 300–1 600 kr/m²
		// (bastupunkten.se), a two-pane unit doubles the glass and adds the
		// sealed spacer. An exterior glass wall has to insulate, so it is the
		// tempered isolerglas unit (6H + 6H, interglas.se), not a single pane.
		id: "prices.panoramaglas",
		category: "prices",
		label: "Panoramaglas",
		description: "Härdat isolerglas 6H + 6H, måttbeställt",
		defaultValue: 3000,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		// A side plate for a wood heater: Harvia's Cilindro plate is 1 990 kr
		// (eldabutiken.se, 2026-09); the full WL450 wall is 2 700–4 300 kr.
		id: "prices.stralskydd",
		category: "prices",
		label: "Strålskydd",
		description: "Skyddsplåt vid bastuaggregat, per plåt",
		defaultValue: 2000,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.mellendorr",
		category: "prices",
		label: "Mellendörr",
		description: "Bastudörr, invändig",
		defaultValue: 3800,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.ytterdorr",
		category: "prices",
		label: "Ytterdörr",
		description: "Bastudörr (glas)",
		defaultValue: 4500,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.betongplint",
		category: "prices",
		label: "Betongplint",
		description: "Plint Ø160×500 mm exkl. separat grundinfästning",
		defaultValue: 185,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.stolpsko",
		category: "prices",
		label: "Stolpsko / infästning",
		description: "Stolpsko, vinkelbeslag och grundinfästning",
		defaultValue: 79,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.kantbrada",
		category: "prices",
		label: "Kantbräda altan",
		description:
			"22×145 mm (22×195 till 45×170-reglar) tryckimpregnerad kantbräda runt altanens öppna kanter, prissatt som vindskivan",
		defaultValue: 28,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.barlina",
		category: "prices",
		label: "Bärlina",
		description: "45×145 NTR-A tryckimpregnerad",
		defaultValue: 65,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.markduk",
		category: "prices",
		label: "Markduk",
		description: "Geotextil för plint- och deckgrund",
		defaultValue: 22,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.draneringsgrus",
		category: "prices",
		label: "Dräneringsgrus / makadam",
		description: "Makadam 8/16 med sättlager för plintar och gångyta",
		defaultValue: 160,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.raspont",
		category: "prices",
		label: "Råspont",
		description: "23 mm råspont / underlagsspont",
		defaultValue: 165,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.underlagspapp",
		category: "prices",
		label: "Underlagspapp",
		description: "Takunderlag på råspont",
		defaultValue: 55,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.ytpapp",
		category: "prices",
		label: "Ytpapp",
		description: "1-lag tätskikt för låglutande tak",
		defaultValue: 145,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.takplat",
		category: "prices",
		label: "Takplåt",
		description: "Bandtäckt / prefalsad takplåt",
		defaultValue: 320,
		valueType: "number",
		unit: "kr/m²",
	},
	{
		id: "prices.takfotsplat",
		category: "prices",
		label: "Takfotsplåt",
		description: "Lackerad takfotsplåt / droppkant",
		defaultValue: 85,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.vindskiveplat",
		category: "prices",
		label: "Vindskiveplåt",
		description: "Lackerad vindskiveplåt",
		defaultValue: 110,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.nockbeslag",
		category: "prices",
		label: "Nockbeslag",
		description: "Lackerat nockbeslag för sadeltak",
		defaultValue: 125,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.silikonkabel",
		category: "prices",
		label: "Silikonkabel SiHF",
		description: "SiHF 3×1.5 mm² 180°C",
		defaultValue: 95,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.standardKabel",
		category: "prices",
		label: "Standard Kabel",
		description: "EKK 3×1.5 mm²",
		defaultValue: 18,
		valueType: "number",
		unit: "kr/lpm",
	},
	{
		id: "prices.kopplingsmaterial",
		category: "prices",
		label: "Kopplingsmaterial",
		description: "Kopplingsdosa, klammer, skyddsrör och småel",
		defaultValue: 950,
		valueType: "number",
		unit: "kr/paket",
	},
	{
		id: "prices.bastuarmatur",
		category: "prices",
		label: "Bastuarmatur",
		description: "Värmetålig bastubelysning / armatur",
		defaultValue: 1495,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.rostfriSkruv",
		category: "prices",
		label: "Rostfri skruv / beslagspaket",
		description: "Rostfri/skyddad skruv, beslag och infästning",
		defaultValue: 395,
		valueType: "number",
		unit: "kr/paket",
	},
	{
		id: "prices.trallskruv",
		category: "prices",
		label: "Trallskruv",
		description: "Rostfri trallskruv för altan och golvdetaljer",
		defaultValue: 349,
		valueType: "number",
		unit: "kr/paket",
	},
	{
		id: "prices.ytbehandling",
		category: "prices",
		label: "Ytbehandling / färg / olja",
		description: "Grundolja, fasadfärg och invändig finish där tillämpligt",
		defaultValue: 1195,
		valueType: "number",
		unit: "kr/paket",
	},
	{
		id: "prices.bastuskorsten",
		category: "prices",
		label: "Bastuskorsten",
		description:
			"Harvia WHP1500: isolerad stålskorsten Ø220 mm, 1,5 m, med 1 m rökrör Ø115, regnhuv, regnkrage och genomföringsfläns (Bygghemma 2026-10-08)",
		defaultValue: 4698,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.bastuskorstenForlangning",
		category: "prices",
		label: "Förlängning bastuskorsten 1,0 m",
		description: "Harvia WHP1000, Ø220 mm (Bygghemma 2026-10-08)",
		defaultValue: 3590,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.bastuskorstenForlangningKort",
		category: "prices",
		label: "Förlängning bastuskorsten 0,5 m",
		description: "Harvia WHP500, Ø220 mm (Bauhaus 2026-10-08)",
		defaultValue: 2495,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.brandtatning",
		category: "prices",
		label: "Brandtätning takgenomföring",
		description: "Obrännbar stenull A1, 100 mm tjocklek runt rör",
		defaultValue: 300,
		valueType: "number",
		unit: "kr/st",
	},
	{
		id: "prices.heaterModel.harvia-m3",
		category: "prices",
		label: "Harvia M3",
		description:
			"Aggregatkatalogen (issue 159). Svenskt butikspris 2026-09-26.",
		defaultValue: 4254,
		valueType: "number",
		unit: "kr/st",
		source: "https://badhuset.se/m3-vedeldad-bastuaggregat",
	},
	{
		id: "prices.heaterModel.harvia-m3-sl",
		category: "prices",
		label: "Harvia M3 SL",
		description:
			"Aggregatkatalogen (issue 159). Svenskt butikspris 2026-09-26.",
		defaultValue: 7653,
		valueType: "number",
		unit: "kr/st",
		source: "https://badhuset.se/m3-sl-vedeldad-bastuaggregat",
	},
	{
		id: "prices.heaterModel.harvia-legend-150",
		category: "prices",
		label: "Harvia Legend 150",
		description:
			"Aggregatkatalogen (issue 159). Svenskt butikspris 2026-09-26.",
		defaultValue: 10990,
		valueType: "number",
		unit: "kr/st",
		source: "https://eldabutiken.se/produkt/harvia-legend-150-2/",
	},
	{
		id: "prices.heaterModel.harvia-legend-150-sl",
		category: "prices",
		label: "Harvia Legend 150 SL",
		description:
			"Aggregatkatalogen (issue 159). Svenskt butikspris 2026-09-26.",
		defaultValue: 15791,
		valueType: "number",
		unit: "kr/st",
		source:
			"https://www.proffsmagasinet.se/bygg-interior/bastu/kaminer/harvia-legend-150-sl-bastuaggregat-vedeldat-4059318",
	},
	{
		id: "prices.heaterModel.harvia-vega-bc60",
		category: "prices",
		label: "Harvia Vega BC60",
		description:
			"Aggregatkatalogen (issue 159). Svenskt butikspris 2026-09-26.",
		defaultValue: 4699,
		valueType: "number",
		unit: "kr/st",
		source:
			"https://www.skanskabyggvaror.se/bastu/bastuaggregat-och-tillbehor/bastuaggregat-harvia-vega-bc60-6-kw-steel-419943",
	},
	{
		id: "prices.heaterModel.harvia-vega-bc90",
		category: "prices",
		label: "Harvia Vega BC90",
		description:
			"Aggregatkatalogen (issue 159). Svenskt butikspris 2026-09-26.",
		defaultValue: 4313,
		valueType: "number",
		unit: "kr/st",
		source: "https://esaunashop.se/harvia-vega-bc90-med-kontrollpanel",
	},
	{
		// Outside-fired heaters (issue 159): the wall the feed tunnel passes
		// through is lined with non-combustible board on both faces.
		id: "prices.brandskivaKalciumsilikat",
		category: "prices",
		label: "Brandskiva kalciumsilikat",
		description:
			"Kalciumsilikatskiva 1220×1000×50 mm vid genomföring för aggregat som eldas utifrån",
		defaultValue: 2599,
		valueType: "number",
		unit: "kr/st",
		source:
			"https://www.vindobyggvaror.se/Produkter/Invandigt/Bad,_bastu,_kok/Brandskiva_kalciumsilikat_1220x1000x50_mm?id=135880",
	},
] as const satisfies readonly RuleDefinition[];
